import { Icon } from 'iconsax-react';

const Close: Icon = (props) => {
  const size = props.size || 24;

  return (
    <svg
      width={size}
      height={size}
      className={props.className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.46484 6.46484L13.5359 13.5359"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46409 13.5359L13.5352 6.46484"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Close;
